import { CountBadge, Status, formatEuro } from '@elbklar/ui';
import { Anfrage, AnfrageStatus } from '@/lib/api';
import { AnfrageCard } from './AnfrageCard';

interface KanbanColumnProps {
  status: AnfrageStatus;
  anfragen: Anfrage[];
  customerNames: Record<string, string>;
  onAnfrageClose?: (anfrage: Anfrage) => void;
  onDragOver: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent, status: AnfrageStatus) => void;
}

const formatCurrency = (value: number) => formatEuro(value);

function anfrageValue(anfrage: Anfrage): number {
  if (anfrage.value === null || anfrage.value === undefined) return 0;
  const num =
    typeof anfrage.value === 'string' ? parseFloat(anfrage.value) : anfrage.value;
  return Number.isNaN(num) ? 0 : num;
}

export function KanbanColumn({
  status,
  anfragen,
  customerNames,
  onAnfrageClose,
  onDragOver,
  onDrop,
}: KanbanColumnProps) {
  const totalValue = anfragen.reduce((sum, a) => sum + anfrageValue(a), 0);

  return (
    <div
      className="flex max-h-full w-72 shrink-0 flex-col rounded-lg bg-muted"
      onDragOver={onDragOver}
      onDrop={(e) => onDrop(e, status)}
    >
      {/* Column Header */}
      <div className="border-b border-border p-3">
        <div className="flex items-center gap-2">
          <h3>
            <Status status={status} />
          </h3>
          <CountBadge className="ml-auto">{anfragen.length}</CountBadge>
        </div>
        {totalValue > 0 && <p className="mt-1.5 t-mono text-muted-foreground">{formatCurrency(totalValue)}</p>}
      </div>

      {/* Cards Container */}
      <div className="flex-1 space-y-2 overflow-y-auto p-2">
        {anfragen.map((anfrage) => (
          <AnfrageCard
            key={anfrage.id}
            anfrage={anfrage}
            customerName={customerNames[anfrage.customer_id]}
            onClose={onAnfrageClose}
          />
        ))}

        {anfragen.length === 0 && (
          <p className="py-8 text-center t-small text-muted-foreground">Keine Anfragen</p>
        )}
      </div>
    </div>
  );
}
